function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styles from './styles.module.scss';
import Button from '@profile/src/Components/Button';
import Modal from '@profile/src/Components/PopupModal_V2';
import { useTestId } from '@wolffun/testable-id';

const ConnectGameModal = ({
  onClickLinkAccount,
  onClickCreateAccount,
  onClose
}) => {
  const {
    generateTestIdProps
  } = useTestId();
  return /*#__PURE__*/React.createElement(Modal, _extends({}, generateTestIdProps('close'), {
    onClose: onClose
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "You are almost there!"), /*#__PURE__*/React.createElement("span", {
    className: styles.desc
  }, "Connect your game account to continue on marketplace"), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement(Button, _extends({
    onClick: () => {
      onClickLinkAccount();
      onClose();
    },
    className: styles.btnCreate,
    title: "Link to Existing game account"
  }, generateTestIdProps('link-account'))), /*#__PURE__*/React.createElement(Button, _extends({
    onClick: () => {
      onClickCreateAccount();
      onClose();
    },
    className: styles.btn,
    title: "Create new game account"
  }, generateTestIdProps('create-account')))));
};

export default ConnectGameModal;